import styled from 'styled-components'
import { useCraft } from '../lib/craft'
import Container, { Expander } from './layout/Container'
import Background from './layout/Background'
import Stack, { StackItem } from './layout/Stack'
import Image from './Image'
import Button from './Button'
import PartnerLogo from './PartnerLogo'

function HeroIllustration( {
  title,
  subtitle,
  illustration,
  buttonLabel,
  buttonLink,
  partnerLabel = null,
  partnerLogos = null,
} ) {
  const craftData = useCraft()
  const illustrations = craftData?.pageProps?.illustrations
  const image = illustrations?.length && illustration && illustrations.find( i => i.filename === `${ illustration }.svg` )
  const bgColor = 'linear-gradient(97.79deg, #96DAEA -41.82%, #D7F0F1 81.37%)'

  if ( !image ) {
    return null
  }

  return (
    <Expander>
      <Background $color={ bgColor }>
        <Container $containerType="full">
          <StyledHeroGrid>
            <StyledHeroContent>
              <Stack
                $flex
                $top={ 8 }
                $bottom={ 8 }
                $between={ 2 }
              >
                <h1>{ title }</h1>
                <p>{ subtitle }</p>
                { buttonLink && (
                  <StackItem
                    $top={ 2 }
                  >
                    <Button 
                      color="red"
                      href={ buttonLink }
                    >
                      { buttonLabel }
                    </Button>
                  </StackItem>
                ) }
                { partnerLogos?.length > 0 && (
                  <StackItem
                    $top="auto"
                  >
                    <PartnerLogo
                      label={ partnerLabel }
                      logos={ partnerLogos }
                    />
                  </StackItem>
                ) }
              </Stack>
            </StyledHeroContent>
            <StyledIllustration>
              <Image
                src={ image.url }
                alt={ image.alt }
                dateModified={ image.dateModified }
                layout="fill"
                objectFit="contain"
                objectPosition="bottom left"
              />
            </StyledIllustration>
          </StyledHeroGrid>
        </Container>
      </Background>
    </Expander>
  )
}

const breakpoint = 600

const StyledHeroGrid = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;

  @media ( max-width: ${ breakpoint }px ) {
    flex-direction: column;
  }
`

const StyledIllustration = styled.div`
  position: relative;
  overflow: hidden;
  flex: 0 0 calc( 50% - ( 2 * ( var( --grid-gutter) ) ) + 40rem );
  margin-left: -40rem;

  @media ( min-width: ${ breakpoint + 1 }px ) and ( max-width: 950px ) {
    flex-basis: 40%;
    margin-left: -5rem;
  }

  @media ( max-width: ${ breakpoint }px ) {
    flex-basis: 40vw;
    margin-left: -5rem;
  }
`

const StyledHeroContent = styled.div`
  display: flex;
  max-width: 530px;
  padding-left: calc( 4 * var( --grid-gutter ) );
  padding-right: 3rem;
  margin-right: auto;
  color: ${ p => p.theme.colors.blue700 };

  h1 {
    ${ p => p.theme.typo.heroTitle };
    line-height: 1.1;
  }

  p {
    ${ p => p.theme.typo.heroSubTitle };
  }

  @media ( max-width: ${ breakpoint }px ) {
    flex-basis: 65vw;
    padding-left: var( --container-margin-width );
  }
`

export default HeroIllustration
